import api from '../api/axios';

const withBase = (path: string) => `/video-dubbing-jobs${path}`;

export interface VideoTranscription {
  id: string;
  dubbingJobId: string;
  videoUrl: string;
  title: string | null;
  description: string | null;
  videoType: string | null;
  audioUrl: string | null;
  deepgramResponse: any;
  processedTranscript: any | null;
  totalDuration: number | null;
  detectedSpeakers: number | null;
  status: 'pending' | 'processing' | 'completed' | 'failed';
  errorMessage: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface VideoDubbingJob {
  id: string;
  videoUrl: string;
  title: string;
  description: string | null;
  sourceLanguage: string;
  videoType: string | null;
  speakerCount: number | null;
  characterMetadata: any | null;
  status: 'pending' | 'transcribing' | 'transcribed' | 'failed';
  transcriptionJobId: string | null;
  errorMessage: string | null;
  transcriptions?: VideoTranscription[];
  createdAt: string;
  updatedAt: string;
}

export interface CreateVideoDubbingJobDto {
  videoUrl: string;
  title: string;
  description?: string | null;
  sourceLanguage: string;
  videoType?: string | null;
  speakerCount?: number | null;
  characterMetadata?: any | null;
}

export interface PaginatedResponse {
  data: VideoDubbingJob[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export const createVideoDubbingJob = async (payload: CreateVideoDubbingJobDto) => {
  const res = await api.post(withBase(''), payload);
  return res.data as VideoDubbingJob;
};

export const getVideoDubbingJobsPaginated = async (page: number = 1, limit: number = 30, search?: string) => {
  const params: any = { page, limit };
  if (search) params.search = search;
  const res = await api.get(withBase('/paginated'), { params });
  return res.data as PaginatedResponse;
};

export const getVideoDubbingJob = async (id: string) => {
  const res = await api.get(withBase(`/${id}`));
  return res.data as VideoDubbingJob;
};

export const updateVideoDubbingJob = async (id: string, payload: Partial<CreateVideoDubbingJobDto>) => {
  const res = await api.patch(withBase(`/${id}`), payload);
  return res.data as VideoDubbingJob;
};

export const deleteVideoDubbingJob = async (id: string) => {
  const res = await api.delete(withBase(`/${id}`));
  return res.data;
};

export const updateCharacterMetadata = async (id: string, characterMetadata: any) => {
  const res = await api.patch(withBase(`/${id}/character-metadata`), { characterMetadata });
  return res.data as VideoDubbingJob;
};

export const updateTranscriptSegments = async (transcriptionId: string, segments: any[]) => {
  const res = await api.patch(`/video-transcriptions/${transcriptionId}/segments`, { segments });
  return res.data;
};

const videoDubbingJobsService = {
  createVideoDubbingJob,
  getVideoDubbingJobsPaginated,
  getVideoDubbingJob,
  updateVideoDubbingJob,
  deleteVideoDubbingJob,
  updateCharacterMetadata,
  updateTranscriptSegments,
};

export default videoDubbingJobsService;
